import { DescriptionStruct } from '@eventr/common'
import { Typography } from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { Fragment } from 'react'

interface HotelDescriptionProps {
    description?: DescriptionStruct[]
}
export const HotelDescription = ({ description }: HotelDescriptionProps) => {
    return (
        <Fragment>
            {description?.map((desc, i) => (
                <div key={i}>
                    <Typography variant="bodyBold">{desc?.title}</Typography>
                    <Box padding={'0 0 0 8px'}>
                        {desc?.paragraphs.map((p, i) => (
                            <Typography
                                variant="bodySubtext"
                                lineHeight={'16px'}
                                dangerouslySetInnerHTML={{ __html: p }}
                                key={i}
                            />
                        ))}
                    </Box>
                </div>
            ))}
        </Fragment>
    )
}
